import analytics from '@utils/analytics';
import einsteinutils from '@utils/einsteinutils';
import { slugify } from '@utils/stringUtils';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProductTile from '@moncler/components/listing/ProductTile';
const ProductCarouselFlpRecommended = (props) => {
    const { t } = useTranslation();
    const [products, setProducts] = useState();
    const container = useRef();
    useEffect(() => {
        const cancelTokenSource = axios.CancelToken.source();
        einsteinutils.productRecommendations(props.recommended, (rec) => {
            var _a, _b;
            setProducts(rec.products);
            const componentParent = (_a = container.current) === null || _a === void 0 ? void 0 : _a.closest('[data-react="recommendationscarousel-app"]');
            componentParent === null || componentParent === void 0 ? void 0 : componentParent.classList.add('products-loaded');
            if (rec.products.length > 0) {
                // analytics.productImpressionsRecommended(rec.products, 'recommended_my_moncler');
                analytics.productImpressionsRecommended(rec.products, `recommended_${props.pageType}_${slugify(rec.displayMessage)}`);
            }
            else {
                // non dovrebbe mai succedere questo caso (se viene configurato correttamente un recommender), causa un reflow del dom
                document.querySelector(`[data-option-uuid="${props.uuid}"]`).classList.remove('skeleton-loading');
                const carouselWrapper = (_b = container.current) === null || _b === void 0 ? void 0 : _b.closest('.product-carousel');
                if (carouselWrapper) {
                    const recoSwitch = carouselWrapper.querySelector(`[data-switch="${props.id}"]`);
                    if (recoSwitch) {
                        // carosello
                        const currentReco = carouselWrapper.querySelector(`[data-id="${props.id}"]`);
                        if (!currentReco.classList.contains('hide')) {
                            currentReco.classList.add('hide');
                        }
                        currentReco.nextElementSibling ? currentReco.nextElementSibling.classList.remove('hide') : currentReco.previousElementSibling.classList.remove('hide');
                        // switch caroselli
                        if (recoSwitch.classList.contains('active')) {
                            recoSwitch.classList.remove('active');
                        }
                        recoSwitch.nextElementSibling ? recoSwitch.nextElementSibling.classList.add('active') : recoSwitch.previousElementSibling.classList.add('active');
                        recoSwitch.style.display = 'none';
                    }
                    else {
                        carouselWrapper.style.display = 'none';
                    }
                }
            }
        }, cancelTokenSource);
        return () => cancelTokenSource.cancel();
    }, []);
    if (!products) {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: props === null || props === void 0 ? void 0 : props.placeholder } });
    }
    return (React.createElement("div", { ref: container, className: "swiper-container" }, products.length === 0 ? (window.devmode ? (React.createElement("div", { className: "devmode devmodebox" },
        "RECOMMENDATION SLOT ",
        props.recommended,
        " ",
        props.recommended && `recommender: ${props.recommended}`,
        " ",
        (products === null || products === void 0 ? void 0 : products.length) === 0 && '- NO RECOMMENDATIONS RECEIVED')) : (React.createElement(React.Fragment, null))) : (React.createElement(React.Fragment, null,
        React.createElement("ul", { className: "swiper-wrapper" }, products.map((product, i) => (React.createElement("li", { key: i, className: "swiper-slide" },
            React.createElement(ProductTile, { type: "RECS", componentUuid: props.uuid, disableQuickShop: props.disableQuickShop, hidelabels: props.hidelabels, hideprice: props.hideprice, pageType: props.pageType, hoverDifferent: props.hoverDifferent, recommender: props === null || props === void 0 ? void 0 : props.recommended, product: product, index: i }))))),
        React.createElement("button", { className: "swiper-button-prev carousel-container__navigation-button", "aria-label": t('carousel.prevslidemessage') },
            React.createElement("span", { className: "carousel-container__button__wrapper" },
                React.createElement("span", { className: "button button--arrow-left" },
                    React.createElement("span", { className: "button__text" }, t('label.more'))))),
        React.createElement("button", { className: "swiper-button-next carousel-container__navigation-button", "aria-label": t('carousel.nextslidemessage') },
            React.createElement("span", { className: "carousel-container__button__wrapper" },
                React.createElement("span", { className: "button button--arrow-right" },
                    React.createElement("span", { className: "button__text" }, t('label.more')))))))));
};
export default ProductCarouselFlpRecommended;
